import { addressSuggestSingle, getCategories } from '../api';
import formateCentroide from './formateCentroide';

export const fetchAddress = (updateAddress, updateLatLng, updateCategories, updateInBounds, formikRef, callback) => {
  const streetName = formikRef.current.values['streetName'];
  const houseNumber = formikRef.current.values['houseNumber'];
  const postcode = formikRef.current.values['postcode'];
  const location = formikRef.current.values['location'];
  if (!streetName || !houseNumber || !postcode || !location) return null;
  addressSuggestSingle(`${streetName} ${houseNumber} ${postcode} ${location}`, (address) => {
    const gpsCoordinates = formateCentroide(address.centroide_ll);
    updateAddress(address);
    updateLatLng(gpsCoordinates);
    getCategories(gpsCoordinates, (categories) => {
      updateCategories(categories);
    }, (inBoundary) => {
      if (inBoundary === 'success') callback();
      updateInBounds(inBoundary);
    });
  });
};
